export default {"src":"/_next/static/media/undraw_travel.94873a69.svg","height":521,"width":850,"blurWidth":0,"blurHeight":0};